import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { sendOtp } from "../services/beneficiaries";
import { NumericFormat } from "react-number-format";
import { ToastContainer } from "react-toastify";
import { api, handleToast } from "../services/config";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export function PasswordUser() {
  const [load, setLoad] = useState(false);
  const navigate = useNavigate();
  const { register, handleSubmit, errors, watch } = useForm();

  const handlSendOTP = async () => {
    const bodyOtp = {
      mobile: localStorage.mobile, // در صورتی که کاربر وارد نشده بود
    };
    try {
      setLoad(true);
      let res = await sendOtp(bodyOtp);
      handleToast("success", "کد ارسال شده را وارد کنید");
    } catch (error) { }
    setTimeout(() => {
      setLoad(false);
    }, 500);
  };

  const handleSendRequest = async () => {
    const old_password = document.getElementById("old_password").value;
    const new_password = document.getElementById("new_password").value;
    const confirm_password = document.getElementById("confirm_password").value;

    // Check if new_password and confirm_password match
    if (new_password !== confirm_password) {
      alert("رمز عبور جدید و تکرار آن باید یکسان باشند");
      return;
    }

    try {
      setLoad(true);

      // Prepare data for API
      const requestData = {
        old_password,
        new_password,
        confirm_password
      };

      // Send data to API using Axios
      const response = await api.post(
        "/change-password",
        requestData, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'authorization': `Bearer ${localStorage.getItem('login')}`
        }
      }
      );

      handleToast("success", response.data.message);

      setTimeout(()=>{
        window.location.reload()
      },3000)
      
    } catch (error) {
      console.error("Error sending request:", error);
      handleToast('error',error.response.data.message)
    } finally {
      setLoad(false);
    }
  };

  return (
    <div className="w-full">
      <ToastContainer />

      <div className="w-[80%] md:w-[60%] lg:w-[30%] h-auto py-5 px-3  mx-auto mt-10 rounded-lg flex flex-col items-center justify-center border border-1 border-gray-100">
        <div className="relative w-full">
          <label
            htmlFor="password"
            className="absolute -top-2 right-2 inline-block bg-white px-1 text-xs font-medium text-gray-900"
          >
            رمز فعلی
          </label>
          <input
            type="password"
            name="old_password"
            dir="ltr"
            id="old_password"
            className="block w-full rounded-md border-0 py-2 text-gray-900 pl-2 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            placeholder="*******"
          />
        </div>
        <div className="relative w-full mt-5">
          <label
            htmlFor="password"
            className="absolute -top-2 right-2 inline-block bg-white px-1 text-xs font-medium text-gray-900"
          >
            رمز جدید
          </label>
          <input
            type="password"
            name="new_password"
            dir="ltr"
            id="new_password"
            className="block w-full rounded-md border-0 py-2 text-gray-900 pl-2 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            placeholder="*******"
          />
        </div>
        <div className="relative w-full mt-5">
          <label
            htmlFor="password"
            className="absolute -top-2 right-2 inline-block bg-white px-1 text-xs font-medium text-gray-900"
          >
            تکرار رمز جدید
          </label>
          <input
            type="password"
            name="confirm_password"
            dir="ltr"
            id="confirm_password"
            className="block w-full rounded-md border-0 py-2 text-gray-900 pl-2 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            placeholder="*******"
          />
        </div>
        <div className="relative w-full  mt-5 flex gap-1">
          <div className="w-4/6">
            <label
              htmlFor="code"
              className="absolute -top-2 right-2 inline-block bg-white px-1 text-xs font-medium text-gray-900"
            >
              کد تایید
            </label>
            <input
              type="text"
              name="code"
              dir="ltr"
              id="code"
              className="block w-full rounded-md border-0 py-2 text-gray-900 pl-2 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              placeholder=""
            />
          </div>

          <div className="w-2/6">
            <button
              className="text-center bg-blue-500 w-full py-2.5 mr-auto text-white rounded text-[12px]"
              onClick={handlSendOTP}
            >
              ارسال کد تایید
            </button>
          </div>
        </div>
        <div className="mt-3 w-full">
          <button
            onClick={() => handleSendRequest()}
            className="text-center  bg-blue-500 w-full py-2.5 mr-auto text-white rounded text-[12px]">ارسال درخواست</button>
        </div>
      </div>
    </div>
  );
}
